import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, withComponentInputBinding} from '@angular/router';

import {routes} from './app.routes';
import {provideHttpClient, withInterceptors, withXhr} from '@angular/common/http';
import {tokenInterceptor} from '@core/interceptors/token.interceptor';
import {languageInterceptor} from '@core/interceptors/language.interceptor';
import {AppTranslateModule} from '@shared/app-translate.module';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import { GaugeChart } from 'echarts/charts';


import {provideEchartsCore} from 'ngx-echarts';
import * as echarts from 'echarts/core';
import {
  BarChart,
  LineChart,
  PieChart
} from 'echarts/charts';
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
  ToolboxComponent
} from 'echarts/components';
import {CanvasRenderer} from 'echarts/renderers';
// import { GoogleMapsModule } from '@angular/google-maps';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { PublicService } from './core/services/public.service';
echarts.use([
  BarChart,
  LineChart,
  PieChart,
  GaugeChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
  ToolboxComponent,
  CanvasRenderer
]);


export const appConfig: ApplicationConfig = {
  providers:
    [
      PublicService,
      provideZoneChangeDetection({eventCoalescing: true}),
      provideRouter(routes , withComponentInputBinding() ),
      provideHttpClient(withXhr() ,withInterceptors([languageInterceptor, tokenInterceptor])),
      importProvidersFrom(AppTranslateModule.forRoot()),
      provideAnimationsAsync(),
      provideEchartsCore({echarts}),
      providePrimeNG({
        theme: {
            preset: Aura, // ده البديل لملف theme.css اللي كان بيطلع خطأ
            options: {
              // Change 'system' to a custom class.
              // Since this class won't be on your HTML by default, it stays LIGHT.
              darkModeSelector: '.my-app-dark',
            }
        }
    })
    ]

};
